module.exports = __webpack_public_path__ + "static/img/center.215c4a51.svg";